var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClockAlert = function SvgClockAlert(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF4246",
    clipPath: "url(#clock_alert_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.013 10.905-2.95-1.767V5.094h1.313v3.299l2.31 1.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.219a6.77 6.77 0 0 0-6.344 4.419l.438-.167a3.6 3.6 0 0 1 1.181-.21 5.469 5.469 0 1 1 2.17 7.569c0 .452-.155.89-.437 1.242A6.772 6.772 0 1 0 8 1.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.791 11.063.429-4.376a2.7 2.7 0 0 0-.875-.13 2.6 2.6 0 0 0-.831.13l.42 4.376zM2.636 12.813a.753.753 0 1 0 .753-.753.76.76 0 0 0-.753.752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_alert_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h14v14H1z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClockAlert);
export default ForwardRef;